/**
 * Preferências por usuário e por tela, no hera_go.
 *
 * O armazenamento é genérico: cada tela define o próprio formato dentro de um
 * JSONB, e a linha é chaveada pelo `ID_JOR` do token — a preferência
 * acompanha o usuário em qualquer máquina.
 *
 * Aqui fica só o transporte, sem tratamento de erro: quem chama decide se uma
 * falha cai no padrão em silêncio (leitura de tela) ou precisa avisar o usuário
 * (gravação por clique em "Salvar").
 */

import { api_v1_go } from "../../modules/Axios/api";

interface RespostaPreferencias<T> {
    screen: string;
    preferences: T | null;
}

/** Devolve null no primeiro acesso, quando nada foi salvo ainda. */
export const getScreenPreferences = async <T>(
    tela: string,
): Promise<T | null> => {
    const { data } = await api_v1_go.get<RespostaPreferencias<T>>(
        `/user-screen-preferences/${tela}`,
    );

    return data?.preferences ?? null;
};

/** Substitui o conteúdo inteiro da tela — o chamador mescla antes, se precisar. */
export const putScreenPreferences = async <T>(
    tela: string,
    preferencias: T,
): Promise<void> => {
    await api_v1_go.put(`/user-screen-preferences/${tela}`, preferencias);
};
